import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AsyncElasticsearchMultiSelect from './AsyncElasticsearchMultiSelect';
import { updateAirportMultiselect } from '../../../modules/DataExports/redux/actions';

const placeholderBase = 'Example: PDX or Portland';

const propTypes = {
  dispatch: PropTypes.func,
  identifier: PropTypes.string,
  isMobile: PropTypes.bool,
  value: PropTypes.array,
  onInputOpen: PropTypes.func,
  onInputClose: PropTypes.func,
};

const mapStateToProps = state => ({
  isMobile: state.App.userAgent.isMobile,
});

const AirportMultiSelect = ({
  value,
  identifier,
  dispatch,
  onInputOpen,
  onInputClose,
  isMobile,
}) => (
  <div>
    <AsyncElasticsearchMultiSelect
      dispatch={dispatch}
      identifier={identifier}
      type='airport'
      name='airport-multiselect'
      placeholder={isMobile ? placeholderBase : `${placeholderBase} International Airport`}
      action={updateAirportMultiselect}
      value={value}
      isOptionUnique
      onInputOpen={onInputOpen}
      onInputClose={onInputClose}
    />
  </div>
);

AirportMultiSelect.propTypes = propTypes;

export default connect(mapStateToProps)(AirportMultiSelect);



// WEBPACK FOOTER //
// ./src/components/lib/AirportMultiSelect.js